import { useTranslation } from 'react-i18next'
import { ProductDocuments } from '@/components/ProductCard/components/ProductDocuments'
import { TotalPrice } from '@/components/TotalPrice/TotalPrice'
import { getSummarisedPrice } from '@/utils/getOfferPrice'
import { Button } from 'ui/src/components/Button/Button'
import { Card } from 'ui/src/components/Card/Card'
import { Divider } from 'ui/src/components/Divider/Divider'
import { Text } from 'ui/src/components/Text/Text'
import { CampaignIcon } from 'ui/src/icons/CampaignIcon'
import { yStack } from 'ui/src/patterns/stack'
import { xStack } from 'ui/src/patterns/stack'
import { tokens } from 'ui/src/theme/tokens.css'
import { useCarExtensionOffers } from './CarTrialExtensionOffers'
import { EditExtensionOfferForm } from './EditExtensionOfferForm'

export const TrialExtensionUpsell = () => {
  const { t } = useTranslation(['common', 'carDealership'])
  const {
    selectedOffer,
    hasUserRejectedExtension,
    isSigningWithExtension,
    isExtendingAfterConnectingPayment,
    isLoading,
    addExtensionOffer,
    rejectExtensionOffer,
  } = useCarExtensionOffers()

  if (isSigningWithExtension || isExtendingAfterConnectingPayment || hasUserRejectedExtension) {
    return null
  }

  const { variant } = selectedOffer

  const price = getSummarisedPrice(selectedOffer.cost)

  return (
    <div className={yStack({ gap: 'md' })}>
      <Card.Root variant="accent" data-theme="green">
        <Card.Header className={xStack({ alignItems: 'flex-start' })}>
          <Card.Media>
            <CampaignIcon color={tokens.colors.signal.green.element} size="1.4rem" />
          </Card.Media>

          <Card.Heading>
            <Card.Title variant={{ _: 'standard.16', sm: 'standard.18' }}>
              {t('CAR_TRIAL_UPSELL_TITLE', { ns: 'carDealership' })}
            </Card.Title>
          </Card.Heading>
        </Card.Header>

        <Text color="textTranslucentSecondary" size="xs" balance>
          {t('CAR_TRIAL_UPSELL_DESCRIPTION', { ns: 'carDealership' })}
        </Text>

        <ProductDocuments documents={variant.documents} />

        <EditExtensionOfferForm isUpsell />

        <Divider color={tokens.colors.border.primary} />

        <TotalPrice {...price} label={t('YOUR_PRICE')} />

        <div className={xStack({ gap: 'md' })}>
          <Button variant="primary" onClick={rejectExtensionOffer} disabled={isLoading} fullWidth>
            {t('QUICK_ADD_DISMISS', { ns: 'carDealership' })}
          </Button>

          <Button variant="primary" onClick={addExtensionOffer} loading={isLoading} fullWidth>
            {t('QUICK_ADD_BUTTON', { ns: 'carDealership' })}
          </Button>
        </div>
      </Card.Root>
    </div>
  )
}
